var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('h3',[_vm._v("Speaker Notes")]),_c('p-rich-text',{attrs:{"value":_vm.selectedCard.notes || 'No notes',"canEdit":false,"placeholder":"Speaker notes"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }